import { id } from '@swimlane/ngx-charts';
import { Component, Inject, OnInit, Type } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { HttpService } from 'src/app/services/http/http.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nutrilabel-dashboard',
  templateUrl: './nutrilabel-dashboard.component.html',
  styleUrls: ['./nutrilabel-dashboard.component.scss']
})
export class NutrilabelDashboardComponent implements OnInit {

  constructor(
    private httpSv: HttpService,
    private dialog: MatDialog,
    private toster: ToastrService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.getIngredient()
    this.getCategory()
    this.getAllergens()
    this.getMacroMicro()
  }
  recipeName = ''
  description = ''
  direction = ''
  cookingTime = ''
  price = ''
  calorie = ''


  // Ingredients
  indridentApiData = []
  ingredientSelect: any = ''
  allIngredient = []
  allSelectedIngredient = []
  finalIngredientData = []
  indredientType = []

  getIngredient() {
    let temp
    this.httpSv.getAllNutriIngriedints().subscribe((res) => {
      if (res['status'] == 'TRUE') {
        temp = res['result'].data
        this.indridentApiData = temp
        this.allIngredient = temp.sub_ingredients
      }
    })
    return (this.allIngredient = [
      { id: 1, name: 'Undefine' }
    ]);
  }
  ingredientChangeHandeler(event) {
    let con = this.allSelectedIngredient.findIndex(ele => ele['sub_ingredient_id'] == event[0]['sub_ingredient_id'])
    if (con == -1) {
      this.allSelectedIngredient.push(event[0])
      this.finalIngredientData = JSON.parse(JSON.stringify([...this.finalIngredientData, event[0]]))
    }
    else {
      this.toster.error(`${event[0]['sub_ingredient_name']} already selected`, '', {
        timeOut: 3000
      })
    }
    this.ingredientSelect = []
  }
  ingredientDataHandeler(dataType, data, index) {
    if (dataType == 'food-code') {
      this.finalIngredientData[index]['food_code'] = data
    }
    else if (dataType == 'type') {
      this.finalIngredientData[index]['main_ingredient_id'] = data['ingredient_id']
      this.finalIngredientData[index]['ingredient_name'] = data['ingredient_name']
    }
    else if (dataType == 'weight') {
      this.finalIngredientData[index]['quantity'] = data
    }
  }
  deleteIngridentHandeler(index) {
    this.allSelectedIngredient.splice(index, 1)
    this.finalIngredientData.splice(index, 1)
  }
  openIngredientDialog() {
    const dialogRef = this.dialog.open(IngredientDialog, {
      data: this.indridentApiData['ingredient_types'],
      minWidth: '350px',

    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.allSelectedIngredient.push(result)
        this.finalIngredientData = JSON.parse(JSON.stringify([...this.finalIngredientData, result]))
      }
    })
  }

  // Category name/dish type
  allCategory = []
  selectedCategory = []
  finalCategorytData = []
  getCategory() {
    let temp
    this.httpSv.getNutriDishTypes().subscribe((res) => {
      if (res['status'] == 'TRUE') {
        temp = res['result'].data
        this.allCategory = temp
      }
    })
    return (this.allCategory = [
      { id: 1, name: 'Undefine' }
    ]);
  }
  categoryChangeHandeler(event) {
    this.finalCategorytData = [event]
  }
  openCategoryDialog() {
    const dialogRef = this.dialog.open(CategoryDialog, {
      data: this.allCategory.length,
      minWidth: '350px'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.allCategory = JSON.parse(JSON.stringify([...this.allCategory, ...result]))
        this.finalCategorytData = [JSON.parse(JSON.stringify(result))]
        this.finalCategorytData[0]['dish_type_id'] = "0"
        this.selectedCategory = result.dish_type_id
      }
    })
  }

  // Tags

  allTags = []
  selectedTags = []
  finalTagsData = []
  getTags() {
    setTimeout(() => {
      this.allTags = this.allergenAndDieatryApiData['tags']
    }, 0);
    return (this.allTags = [
      { id: 1, name: 'Undefine' }
    ]);
  }
  tagsChangeHandeler(event) {
    this.finalTagsData = event
  }
  openTagsDialog() {
    const dialogRef = this.dialog.open(AllergensDialog, {
      data: {
        len: this.allTags.length,
        heading: 'Tag name'
      },
      minWidth: '350px'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.allTags = JSON.parse(JSON.stringify([...this.allTags, ...result]))
        this.finalTagsData = JSON.parse(JSON.stringify([...this.finalTagsData, ...result]))
        this.finalTagsData[this.finalTagsData.length - 1]['tag_id'] = "0"
        this.selectedTags = [...this.selectedTags, result.tag_id]
      }
    })
  }

  // Allergens
  allergenAndDieatryApiData = []
  allAllergens = []
  selectedAllergens = []
  finalAllergenstData = []
  getAllergens() {
    let temp
    this.httpSv.getAllNutriCategoryAndAllergens().subscribe((res) => {
      if (res['status'] == 'TRUE') {
        temp = res['result'].data
        this.allergenAndDieatryApiData = temp
        this.allAllergens = temp.allergens
        this.getTags()
        this.getAoAllergens()
        this.getUsDietary()
        this.getStDietary()
        this.getAoDietary()
      }
    })
    return (this.allCategory = [
      { id: 1, name: 'Undefine' }
    ]);

  }
  allergensChangeHandeler(event) {
    this.finalAllergenstData = event
  }
  openAllergensDialog() {
    const dialogRef = this.dialog.open(AllergensDialog, {
      data: {
        len: this.allAllergens.length,
        heading: 'Allergens Name'
      },
      minWidth: '350px'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.allAllergens = JSON.parse(JSON.stringify([...this.allAllergens, ...result]))
        this.finalAllergenstData = JSON.parse(JSON.stringify([...this.finalAllergenstData, ...result]))
        this.finalAllergenstData[this.finalAllergenstData.length - 1]['allergens_id'] = "0"
        this.selectedAllergens = [...this.selectedAllergens, result.allergens_id]
      }
    })
  }
  // Allergens available option
  allAoAllergens = []
  selectedAoAllergens = []
  finalAoAllergenstData = []
  getAoAllergens() {
    setTimeout(() => {
      this.allAoAllergens = this.allergenAndDieatryApiData['allergens']
    }, 0);
    return (this.allAoAllergens = [
      { id: 1, name: 'Undefine' }
    ]);

  }
  aoAllergensChangeHandeler(event) {
    this.finalAoAllergenstData = event
  }
  openAoAllergensDialog() {
    const dialogRef = this.dialog.open(AllergensDialog, {
      data: {
        len: this.allAoAllergens.length,
        heading: 'Allergens available option name'
      },
      minWidth: '350px'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.allAoAllergens = JSON.parse(JSON.stringify([...this.allAoAllergens, ...result]))
        this.finalAoAllergenstData = JSON.parse(JSON.stringify([...this.finalAoAllergenstData, ...result]))
        this.finalAoAllergenstData[this.finalAoAllergenstData.length - 1]['allergens_id'] = "0"
        this.selectedAoAllergens = [...this.selectedAoAllergens, result.allergens_id]
      }
    })
  }

  // Unsuitable dietary preference

  allUsDietary = []
  selectedUsDietary = []
  finalUsDietaryData = []
  getUsDietary() {
    setTimeout(() => {
      this.allUsDietary = this.allergenAndDieatryApiData['dietary_prefer']
    }, 0);
    return (this.allUsDietary = [
      { id: 1, name: 'Undefine' }
    ]);
  }
  usDietaryChangeHandeler(event) {
    this.finalUsDietaryData = event
  }
  openUsDietaryDialog() {
    const dialogRef = this.dialog.open(AllergensDialog, {
      data: {
        len: this.allUsDietary.length,
        heading: 'Unsuitable dietary preference name'
      },
      minWidth: '350px'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.allUsDietary = JSON.parse(JSON.stringify([...this.allUsDietary, ...result]))
        this.finalUsDietaryData = JSON.parse(JSON.stringify([...this.finalUsDietaryData, ...result]))
        this.finalUsDietaryData[this.finalUsDietaryData.length - 1]['diet_preference_id'] = "0"
        this.selectedUsDietary = [...this.selectedUsDietary, result.diet_preference_id]
      }
    })
  }

  // Suitable Dietary Preferance

  allStDietary = []
  selectedStDietary = []
  finalStDietaryData = []
  getStDietary() {
    let temp
    setTimeout(() => {
      this.allStDietary = this.allergenAndDieatryApiData['dietary_prefer']
    }, 0);
    return (this.allStDietary = [
      { id: 1, name: 'Undefine' }
    ]);
  }
  stDietaryChangeHandeler(event) {
    this.finalStDietaryData = event
  }
  openStDietaryDialog() {
    const dialogRef = this.dialog.open(AllergensDialog, {
      data: {
        len: this.allStDietary.length,
        heading: 'Suitable dietary preference name'
      },
      minWidth: '350px'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.allStDietary = JSON.parse(JSON.stringify([...this.allStDietary, ...result]))
        this.finalStDietaryData = JSON.parse(JSON.stringify([...this.finalStDietaryData, ...result]))
        this.finalStDietaryData[this.finalStDietaryData.length - 1]['diet_preference_id'] = "0"
        this.selectedStDietary = [...this.selectedStDietary, result.diet_preference_id]
      }
    })
  }
  // Available Dietary Preferance Option

  allAoDietary = []
  selectedAoDietary = []
  finalAoDietaryData = []
  getAoDietary() {
    let temp
    setTimeout(() => {
      this.allAoDietary = this.allergenAndDieatryApiData['dietary_prefer']
    }, 0);
    return (this.allAoDietary = [
      { id: 1, name: 'Undefine' }
    ]);
  }
  aoDietaryChangeHandeler(event) {
    this.finalAoDietaryData = event
  }
  openAoDietaryDialog() {
    const dialogRef = this.dialog.open(AllergensDialog, {
      data: {
        len: this.allAoDietary.length,
        heading: 'Dietry preference available option name',
      },
      minWidth: '350px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {

        this.allAoDietary = JSON.parse(JSON.stringify([...this.allAoDietary, ...result]))
        this.finalAoDietaryData = JSON.parse(JSON.stringify([...this.finalAoDietaryData, ...result]))
        this.finalAoDietaryData[this.finalAoDietaryData.length - 1]['diet_preference_id'] = "0"
        this.selectedAoDietary = [...this.selectedAoDietary, result.diet_preference_id]
      }
    })
  }
  // Macronutrients and Micronutrients

  macroMicroSelect: any = ''
  allMacroMicro = []
  allSelectedMacroMicro = []
  finalMacroMicroData = {}


  getMacroMicro() {
    let temp
    this.httpSv.getAllMacroMicro().subscribe((res) => {
      if (res['status'] == 'TRUE') {
        temp = res['result'].data
        this.allMacroMicro = temp
      }
    })
    return (this.allMacroMicro = [
      { id: 1, name: 'Undefine' }
    ]);
  }
  macroMicroChangeHandeler(event) {
    let con = this.allSelectedMacroMicro.findIndex(ele => ele == event[0])
    if (con == -1) {
      this.allSelectedMacroMicro.push(event[0])
      let key = event[0]
      this.finalMacroMicroData[key] = ''
    }
    else {
      this.toster.error(`${event[0]} is already selected`, '', {
        timeOut: 3000
      })
    }
    this.macroMicroSelect = []
  }
  macroMicroDataHandeler(data, key) {
    this.finalMacroMicroData[key] = data
  }
  deleteMacroMicroHandeler(index, key) {
    this.allSelectedMacroMicro.splice(index, 1)
    delete this.finalMacroMicroData[key]
  }
  // openMacroMicroDialog(){
  //    const dialogRef = this.dialog.open(AllergensDialog, {
  //     data:{
  //       len:this.finalIngredientData.length,
  //       heading:'Macronutrients and micronutrients name'
  //     },
  //      minWidth:'350px'
  //    });
  //    dialogRef.afterClosed().subscribe((result) => {
  //      if(result){
  //        this.allSelectedIngredient.push(result)
  //        this.finalIngredientData = JSON.parse(JSON.stringify([...this.finalIngredientData,result]))
  //      }
  //    })
  //  }
  ingredientVerify() {
    let falg = true
    this.finalIngredientData.forEach(ele => {
      if (ele.quantity == '' || ele.quantity == null || !ele.quantity) {
        falg = false
        return
      }
    })
    if (falg) return true
    else return false
  }
  macroMicroVerify() {
    let falg = true
    for (let key in this.finalMacroMicroData) {
      if (this.finalMacroMicroData[key] == '') {
        falg = false
        return
      }
    }
    if (falg) return true
    else return false
  }
  addRecipe() {
    if (this.recipeName != '') {
      if (this.cookingTime != '') {
        if (this.calorie != '') {
          if (this.finalIngredientData.length > 0) {
            if (this.ingredientVerify()) {
              console.log(this.finalCategorytData)
              if (this.finalCategorytData.length > 0)
                if (Object.keys(this.finalMacroMicroData).length > 0) {
                  if (this.macroMicroVerify()) {
                    let data = {
                      recipe_name: this.recipeName,
                      description: this.description == '' ? null : this.description,
                      methodology: this.direction == '' ? null : this.direction,
                      cooking_time: this.cookingTime,
                      price: this.price == '' ? null : this.price,
                      calories: this.calorie,
                      ingredient: this.finalIngredientData,
                      category: this.finalCategorytData,
                      tags: this.finalTagsData,
                      allergens: this.finalAllergenstData,
                      allergen_options: this.finalAoAllergenstData,
                      unsuitable_dietary: this.finalUsDietaryData,
                      suitable_dietary: this.finalStDietaryData,
                      dietary_option: this.finalAoDietaryData,
                      nutritions: [this.finalMacroMicroData],
                    }
                    this.httpSv.addNutriRecipe(data).subscribe(res => {
                      if (res['status'] == true) {
                        const dialogRef = this.dialog.open(SuccessDialog, {
                          disableClose: true,
                          minWidth: '400px'
                        });
                      }
                      else {
                        console.log(res)
                        this.toster.error(res['message'], '', {
                          timeOut: 3000
                        })
                        this.router.navigate(['/superadmin/dashboard'])
                      }

                    }, err => {
                      console.log(err)
                      this.toster.error('OOPS!! Something went wrong', '', {
                        timeOut: 3000
                      })
                      this.router.navigate(['/superadmin/dashboard'])
                    })
                  }
                  else {
                    this.toster.error('Please fill the quantity of macronutrients and micronutrients', '', {
                      timeOut: 3000
                    })
                  }
                }
                else {
                  this.toster.error('Please select macronutrients and micronutrients', '', {
                    timeOut: 3000
                  })
                }
              else {
                this.toster.error('Please select recipe category name', '', {
                  timeOut: 3000
                })
              }
            }
            else {
              this.toster.error('Please fill the quantity of ingrident', '', {
                timeOut: 3000
              })
            }
          }
          else {
            this.toster.error('Please select ingrident(s)', '', {
              timeOut: 3000
            })
          }
        }
        else {
          this.toster.error('Please add the calories', '', {
            timeOut: 3000
          })
        }
      }
      else {
        this.toster.error('Please add the cooking time', '', {
          timeOut: 3000
        })
      }
    }
    else {
      this.toster.error('Recipe name missing', '', {
        timeOut: 3000
      })
    }
  }


}
//----------------- main componet ends------------

//------------------------------------------------------------ indrigent dialog -----------------------------------------

@Component({
  selector: 'ingredient-dialog-dashboard',
  templateUrl: './ingredient-dialog.html',
  styleUrls: ['./nutrilabel-dashboard.component.scss']
})
export class IngredientDialog implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<IngredientDialog>,
    private toster: ToastrService,
  ) { }
  ngOnInit(): void {

  }
  name: string = ''
  foodCode: any = ''
  indredientType: any = null
  typeData
  ingredientDataHandeler(event) {
    this.typeData = event
  }
  close() {
    this.dialogRef.close(false)
  }
  addNew() {
    if (this.name == '') {
      this.toster.error('Please enter ingredient name', '', {
        timeOut: 3000,
      })
    }
    else if (this.indredientType == null) {
      this.toster.error('Please select ingredient type', '', {
        timeOut: 3000,
      })
    }
    else {
      this.dialogRef.close({
        sub_ingredient_id: "0",
        main_ingredient_id: this.typeData['ingredient_id'],
        sub_ingredient_name: this.name,
        food_code: this.foodCode ? this.foodCode : null,
        default_quantity: null,
        std_weight_or_unit: null,
        ingredient_name: this.typeData['ingredient_name']
      })
      this.toster.success('Ingredient added', '', {
        timeOut: 2000,
      })
    }
  }
}
//-------------------------------------------------------------- category dialog------------------------------------------ -----

@Component({
  selector: 'category-dialog-dashboard',
  templateUrl: './category-dialog.html',
  styleUrls: ['./nutrilabel-dashboard.component.scss']
})
export class CategoryDialog implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CategoryDialog>,
    private toster: ToastrService,
  ) { }
  ngOnInit(): void {
  }
  name: string = ''

  close() {
    this.dialogRef.close(false)
  }
  addNew() {
    if (this.name == '') {
      this.toster.error('Please fill the new category name', '', {
        timeOut: 3000,
      })
    }
    else {
      this.dialogRef.close({
        dish_type_id: `new${this.data}`,
        dish_type_name: this.name
        , dish_type_status: null
      })
      this.toster.success('Category added', '', {
        timeOut: 2000,
      })
    }
  }
}
//--------------------------------- allergens, unsuitable ,suitable, availabel dietary dialog  -------------------------

@Component({
  selector: 'allergens-dialog-dashboard',
  templateUrl: './allergens-dialog.html',
  styleUrls: ['./nutrilabel-dashboard.component.scss']
})
export class AllergensDialog implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AllergensDialog>,
    private toster: ToastrService,
  ) { }
  ngOnInit(): void {
    this.modify(this.data.heading.toLowerCase())
  }
  modify(data) {
    let lastIndex = data.lastIndexOf(" ");
    this.text = data.substring(0, lastIndex)
  }
  name: string = ''
  text = ''
  close() {
    this.dialogRef.close(false)
  }
  addNew() {
    if (this.name == "") {
      this.toster.error(`Please fill ${this.text} name`, '', {
        timeOut: 3000,
      })
    }
    else {
      if (this.data.heading == 'Allergens Name' || this.data.heading == 'Allergens available option name')
        this.dialogRef.close({ allergens_id: `new${this.data.len}`, allergens_name: this.name })
      else if (this.data.heading == 'Tag name')
        this.dialogRef.close({ tag_id: `new${this.data.len}`, tag_name: this.name })
      else
        this.dialogRef.close({ diet_preference_id: `new${this.data.len}`, diet_preference_name: this.name })
      this.toster.success(`${this.text.charAt(0).toUpperCase() + this.text.slice(1)} added`, '', {
        timeOut: 2000,
      })
    }
  }
}
//---------------------------------Success Added Dialog  -------------------------

@Component({
  selector: 'success-dialog-dashboard',
  templateUrl: './successful-added-dialog.html',
  styleUrls: ['./nutrilabel-dashboard.component.scss']
})
export class SuccessDialog implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<SuccessDialog>,
    private router: Router
  ) { }
  ngOnInit(): void {

  }
  goToDashboard() {
    this.dialogRef.close()
    this.router.navigate(['/superadmin/dashboard'])

  }

}